import React from 'react';
import block from 'bem-cn';
import { shallowEqual, useSelector } from 'react-redux';
import SVG from 'components/SVG';

import arrowSVG from './img/arrow.svg';

import './AssistantBack.scss';

const b = block('assistant-back');

const AssistantBack = ({ model }) => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  return (
    <div className={b()} onClick={model.inputState?.backToPreviousSection}>
      <SVG svgProps={{ svg: arrowSVG }} className={b('arrow')} />
      <span className={b('text')}>{locale.back}</span>
    </div>
  );
};

export default AssistantBack;
